import React from 'react';
import './styles.css';

import { isEmpty } from 'lodash';

export default class ProvenanceMap extends React.Component {
  constructor(props) {
    super(props);
    const assetNum = props.location.pathname.substring(1);
      if(!isEmpty(assetNum)) {
        this.state = { 
          serialNo: assetNum,
          imagePath: this.getImagePath(assetNum),
          showText:this.displaySuccessText(assetNum),
          show: true,
        };
      } else {
        this.state = { 
          serialNo: '',
          imagePath: '',
          showText: '',
          show: false,
        };
      }
      this.imgErr = this.imgErr.bind(this);
  }

  getImagePath(assetNum) {
    return `/images/bars/${assetNum}.png`;
  }

  displaySuccessText(assetNum) {
    return `Provenance Map for Responsible Gold \u2122 kilobar ${assetNum}`;
  }

  handleShow() {
    const assetNum = this.refs.barNumberInput.value;
    this.setState({
      serialNo: assetNum,
      imagePath: this.getImagePath(assetNum),
      showText: this.displaySuccessText(assetNum),
      show: true
    });
  }

  imgErr() {
    const assetNum = this.state.serialNo;
    this.setState({
      serialNo: '',
      showText:`Could not find bar ${assetNum}`,
      show: false
    });
  }

  onKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.handleShow();
    }
  }

  render () {
    return (
      <div className="App">
        <div className="App-container">
          <div className="App-header">
            <img className="App-logo" src='/images/logo.svg' alt='logo'/>
            <div className="Provenance-Map">Provenance Map</div>
            <div className="App-title">
              {this.state.showText}
            </div>
            <div  className="App-header-input">
              <input className="App-input" ref="barNumberInput" onKeyDown={this.onKeyDown} /><br/>
              <button onClick={()=>this.handleShow()} className="Rectangle" type="submit">Find Asset</button>
            </div>
            
          </div>
          <div className="App-box">
            {
              this.state.show &&
              <img src={this.state.imagePath} className="App-img" alt="goldbar" onError={this.imgErr}/>
            }
          </div>
        </div>
      </div>
    );
  }
}
